import { render, staticRenderFns } from "./visitDetail.vue?vue&type=template&id=6f8e6e22"
import script from "./visitDetail.vue?vue&type=script&lang=js"
export * from "./visitDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports